export default __webpack_public_path__ + "b3d2a73563364a7d44cbfd891e93fbf0.jpg";